import React from "react";

import "../../../../styles/css/App.css";

import { Grid } from "@material-ui/core";
import CircularProgress from '@mui/material/CircularProgress';
import { withRouter } from "react-router-dom";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useMediaQuery } from 'react-responsive';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import Card from "@material-ui/core/Card";
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import Tooltip from '@mui/material/Tooltip';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import ScheduleRoundedIcon from '@mui/icons-material/ScheduleRounded';
import PeopleRoundedIcon from '@mui/icons-material/PeopleRounded';
import * as Constants from "../../../../consts/Constants.js";
import Scheduler, { Resource } from "devextreme-react/scheduler";
import { locale, loadMessages } from "devextreme/localization";
import LinearProgress from '@mui/material/LinearProgress';

import alerter from "../../../alerts/alerter";
import { formatDateHHMM, formatDateDDMMYYYYHHMM } from "../../../../plas/utils";
import ShiftForm from "./shift-form";
import AttendeesList from "./attendees-list";

import { EventShift } from '../../../../plas/services/shifter/models';

import service from '../../../../plas/services/shifter/service';

function Shifts({ history, eventId }) {

  const isMedium = useMediaQuery({ query: `(max-width: 900px)` });

  const theme = createTheme({
    palette: {
      primary: {
        main: '#FFFFFF',
        darker: '#FFFFFF',
      }
    },
  });

  const [loadingEvent, setLoadingEvent] = React.useState(true);
  const [loadingShifts, setLoadingShifts] = React.useState(false);

  const [event, setEvent] = React.useState(null);
  const [shift, setShift] = React.useState(null);
  const [shifts, setShifts] = React.useState([]);
  const [range, setRange] = React.useState(null);

  const [editShift, setEditShift] = React.useState(null);
  const [attendeesShift, setAttendeesShift] = React.useState(null);

  React.useEffect(() => {
    loadMessages({
      en: { "dxScheduler-switcherMonth": "Mes" },
    });
    locale("es");
    loadEvent()
  }, []);

  const loadEvent = () => {
    setLoadingEvent(true);
    service.api.events.get(eventId, (response) => {
      if (response.error != null) {
        alerter.showError(response.error);
      } else {
        setEvent(response.result);
        setLoadingEvent(false);
      }
    });
  }

  const loadShifts = (range) => {
    let startTime = range[0];
    let endTime = range[1];
    setShifts([]);
    setLoadingShifts(true);

    service.api.shifts.getPage(0, 32767, eventId, startTime, endTime, null, (response) => {
      if (response.error != null) {
        alerter.showError(response.error);
      } else {
        setShifts(response.result.data)
      }
      setRange(range)
      setLoadingShifts(false);
    });
  }

  const newButtonHandler = () => {
     let aux = new EventShift();
     aux.event = event;
     aux.eventId = event.id;
     setEditShift(aux);
  }

  const attendeesButtonHandler = () => {
    setAttendeesShift(shift);
  }

  const editButtonHandler = () => {
    setEditShift(new EventShift(shift));
  }

  const deleteButtonHandler = () => {
    setLoadingShifts(true);
    service.api.shifts.delete(shift.eventId, shift.id, (response) => {
      if (response.error != null) {
        alerter.showError(response.error);
      } else {
        onRemove(shift.id);
      }
      setLoadingShifts(false);
    });
  }

  const preventEvent = (e) => {
    e.cancel = true;
  }

  const selectShift = (e) => {
    e.cancel = true;
    if (shift && shift.id === e.appointmentData.id)
      setShift(null);
    else
      setShift(e.appointmentData);
  }

  const calcColor = (shiftToCalc) => {
    if (shift && shift.id === shiftToCalc.id)
      return rgbToHex(50, 50, 200);

    let percentage = (((shiftToCalc.capacity - shiftToCalc.occupancy) * 100) / shiftToCalc.capacity);

    let r = (255 * Math.min((100 - percentage),80)) / 100 ;
    let g = (255 * Math.min(percentage,80)) / 100;
    let b = 20;

    return rgbToHex(r, g, b);
  }

  const rgbToHex = (r, g, b) => {
    return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
  }

  const closeEdit = () => {
    setEditShift(null);
  }

  const closeAttendees = () => {
    setAttendeesShift(null);
  }

  const onRemove = (shiftId) => {
    setShift(null);

    let pos = -1;
    shifts.forEach((item, index) => {
      if (shiftId === item.id) {
        pos = index;
      }
    });

    if (pos !== -1) {
        shifts.splice(pos, 1);
    }

    setShifts([...shifts]);
  }

  const onChange = (updatedShift) => {
    setEditShift(null);
    
    if (updatedShift.date >= range[0] && updatedShift.date <= range[1]) {
      let shiftAppointment = { ...updatedShift, id: updatedShift.id, startDate: updatedShift.date, endDate: updatedShift.date, text: `${formatDateHHMM(updatedShift.date)} hs`};

      let pos = -1;
      shifts.forEach((item, index) => {
        if (shiftAppointment.id === item.id) {
          pos = index;
        }
      });

      if (pos !== -1) {
        shifts[pos] = shiftAppointment;
      } else {
        shifts.push(shiftAppointment);
      }

      setShift(shiftAppointment);
      setShifts([...shifts]);
    }
  }

  const ColoredLine = ({ color, marginTop, marginBottom }) => (
      <hr
        style={{
          color: color,
          backgroundColor: color,
          marginTop: marginTop !== undefined ? marginTop : 6,
          marginBottom: marginBottom !== undefined ? marginBottom : 6,
          height: 2
        }}
      />
  );


  return (
    <Grid container>
      <Grid item xs={12} style={{ textAlign: "center"}}>
        { loadingEvent ? (
          <CircularProgress style={{color:Constants.COLOR_PRIMARY}} color="inherit" />
        ):(
          <Grid container spacing={0}>
            <Grid item xs={false} md={2} />
            <Grid item xs={12} md={8} >
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Grid container spacing={2}>
                    <Grid item xs={true}>
                      <p style={{ fontSize: '28px', textAlign: 'left'}}>
                        { event.name }
                      </p>
                    </Grid>
                    <Grid item>
                      <ThemeProvider theme={theme}>
                        <Button
                          startIcon={<AddRoundedIcon />}
                          variant="contained"
                          onClick={newButtonHandler}>
                          <b>Nuevo turno</b>
                        </Button>
                      </ThemeProvider>
                    </Grid>
                  </Grid>
                  <ColoredLine color="gray" marginTop={0} marginBottom={0} />              
                </Grid>
                <Grid item xs={12}>
                  <Card elevation={0} style={{padding: 8, backgroundColor: '#F5F5F5'}}>
                    <Grid container spacing={0}>
                      <Grid item xs={12}>
                        <Grid container spacing={2}>
                          <Grid item style={{fontSize: 15}}>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              height="100%"> 
                              <ScheduleRoundedIcon style={{paddingRight: 4}}/>
                              <b>Turno</b>: { shift ? formatDateDDMMYYYYHHMM(shift.date) : "-" }
                            </Box>
                          </Grid>
                          <Grid item xs={true}/>
                          <Grid item>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              height="100%"> 
                              <span style={{ marginRight: 4, fontSize: 14}}>
                                { shift ? `${shift.occupancy} / ${shift.capacity}` : "- / -"}
                              </span>
                              <Tooltip title="Ver asistentes">
                                <span>
                                  <IconButton disabled={!shift || loadingShifts} style={{ marginLeft: 2 }} onClick={attendeesButtonHandler}>
                                    <PeopleRoundedIcon fontSize="small"/>
                                  </IconButton>
                                </span>
                              </Tooltip>
                            </Box>
                          </Grid>
                          <Grid item>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              height="100%"> 
                              <Tooltip title="Editar turno">
                                <span>
                                  <IconButton disabled={!shift || loadingShifts} style={{ marginLeft: 2 }} onClick={editButtonHandler}>
                                    <EditRoundedIcon fontSize="small"/>
                                  </IconButton>
                                </span>
                              </Tooltip>
                            </Box>
                          </Grid>
                          <Grid item>
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              height="100%"> 
                              <Tooltip title="Borrar turno">
                                <span>
                                  <IconButton disabled={!shift || loadingShifts} style={{ marginLeft: 2 }} onClick={deleteButtonHandler}>
                                    <DeleteRoundedIcon fontSize="small"/>
                                  </IconButton>
                                </span>
                              </Tooltip>
                            </Box>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
                <Grid item xs={12}>
                 <Scheduler
                    dataSource={shifts.map((item) => { return {...item, id: item.id, startDate: item.date, endDate: item.date, text: `${formatDateHHMM(item.date)} hs`}})}
                    disabled={loadingShifts}
                    style={{height: '100%'}}
                    defaultCurrentView="month"
                    views={[{ type: "month", intervalCount: 1 }]}
                    editing={{
                      allowAdding: false,
                      allowDeleting: false,
                      allowDragging: false,
                      allowResizing: false,
                      allowTimeZoneEditing: false,
                      allowUpdating: false,
                    }}
                    showAllDayPanel={false}
                    showCurrentTimeIndicator={false}
                    defaultCurrentDate={new Date()}
                    onAppointmentRemove={preventEvent}
                    onAppointmentDeleted={preventEvent}
                    onAppointmentDblClick={preventEvent}
                    onAppointmentFormOpening={preventEvent}
                    onAppointmentClick={selectShift}
                    onContentReady={(e)=> {
                      let newRange = [e.component.getStartViewDate().getTime(), e.component.getEndViewDate().getTime()]
                      if (!loadingShifts && (!range || newRange[0] !== range[0])) {
                        loadShifts(newRange)
                      }
                    }}>
                    <Resource
                      dataSource={shifts.map((item) => { return { id: item.id, color: calcColor(item) }})}
                      fieldExpr="id"
                      useColorAsDefault={true}/>

                    </Scheduler>
                    { loadingShifts ? (<LinearProgress />) : (null) }
                </Grid>
              </Grid>

            </Grid>
            <Grid item xs={false} md={2} />
          </Grid>
        )}
      </Grid>
      { editShift && (
        <Dialog
          maxWidth="sm" 
          fullScreen={isMedium}
          open={true}
          fullWidth={true}>
          <DialogContent style={{ paddingTop: 8, paddingBottom: 8 }}>
            <ShiftForm onCancel={closeEdit} fullWidth={true} eventId={eventId} initialShift={editShift} onSave={onChange}/>
          </DialogContent>
        </Dialog>
      )}
      { attendeesShift && (
        <Dialog
          maxWidth="md" 
          fullScreen={isMedium}
          open={true}
          onClose={closeAttendees}
          fullWidth={true}>
          <DialogContent style={{ paddingTop: 8, paddingBottom: 8 }}>
            <AttendeesList onCancel={closeAttendees} fullWidth={true} shift={attendeesShift}/>
          </DialogContent>
        </Dialog>
      )}
    </Grid>
  );

}

export default withRouter(Shifts);
